<template>
  <div id="app" :class="{ 'has-native-banner': hasNativeBanner }">
    <router-view></router-view>  <!-- This will render the routed component -->
  </div>
</template>

<script>
import { removeAppBannerAd, showAppBannerAd } from "./services/adMobService";

export default {
  name: 'App',
  data() {
    return {
      hasNativeBanner: false,
    };
  },
  async mounted() {
    this.hasNativeBanner = await showAppBannerAd();
  },
  async beforeUnmount() {
    await removeAppBannerAd();
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

#app.has-native-banner {
  padding-bottom: 72px;
  box-sizing: border-box;
}
</style>
